var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntrepriseRecto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 552 555.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#12171c;}.cls-1,.cls-5{stroke:#12171c;}.cls-1,.cls-3,.cls-5,.cls-6{stroke-miterlimit:10;}.cls-2,.cls-3,.cls-6{fill:#fff;}.cls-3,.cls-6{stroke:#33163a;}.cls-4{fill:#dbf226;}.cls-5{fill:none;stroke-width:2px;}.cls-6{opacity:0.82;}.cls-7{fill:#052941;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "entreprise recto") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_7",
    "data-name": "Calque 7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.5,
    y: 10,
    width: 550,
    height: 545,
    rx: 24.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.5,
    y: 1,
    width: 550,
    height: 545,
    rx: 24.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 26.18,
    y: 17.54,
    width: 499.77,
    height: 452.46,
    rx: 28.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M657,1001c252.5,116.5,496-192,330-419.5l195,.5c17,1,29,11,25,34V850s-6.52,189-218.26,276.5C812,1126,682,1127,682,1127c-12,0-26-10-24-33Z",
    transform: "translate(-656 -580.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1.5,
    y: 1,
    width: 549.5,
    height: 545,
    rx: 24.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 26.18,
    y: 17.54,
    width: 499.77,
    height: 452.46,
    rx: 28.07
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_9",
    "data-name": "Calque 9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M866.13,1098v-20.58H869V1098Zm1.4-17.84v-2.74h11.82v2.74Zm0,9v-2.74h10.26v2.74Zm0,8.85v-2.74h11.82V1098Z",
    transform: "translate(-656 -580.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M883.18,1098v-14.69h2.88V1098Zm8.92,0v-8.9a3.4,3.4,0,0,0-.8-2.41,3.51,3.51,0,0,0-4.46-.1,2.78,2.78,0,0,0-.78,2.11l-.29-2.83a5.18,5.18,0,0,1,1.77-2,4.28,4.28,0,0,1,2.43-.73,4.59,4.59,0,0,1,3.71,1.57,6.71,6.71,0,0,1,1.3,4.42V1098Z",
    transform: "translate(-656 -580.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M898.24,1085.91v-2.6h6.63v2.6Zm5,12.16a3.19,3.19,0,0,1-2.63-1,4.5,4.5,0,0,1-.81-2.89V1079h2.89v15.18a1.4,1.4,0,0,0,.21.82.71.71,0,0,0,.62.3h1.39v2.74Z",
    transform: "translate(-656 -580.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M908.83,1098v-14.69h2.89V1098Zm8.09-11.21a2.51,2.51,0,0,0-1-.71,3.54,3.54,0,0,0-1.35-.24,2.86,2.86,0,0,0-2.13.76,2.8,2.8,0,0,0-.76,2.1l-.3-2.83a5.4,5.4,0,0,1,1.75-2,4.19,4.19,0,0,1,2.39-.74,5.47,5.47,0,0,1,1.82.29,4.1,4.1,0,0,1,1.42.86Z",
    transform: "translate(-656 -580.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M926.94,1098.22a6.33,6.33,0,0,1-4.75-1.72,6.62,6.62,0,0,1-1.69-4.87V1090a7.34,7.34,0,0,1,1.62-5.08,5.84,5.84,0,0,1,4.57-1.8,5.06,5.06,0,0,1,4.3,2,9.44,9.44,0,0,1,1.52,5.72v1H922.6v-2.33h7.16a4.87,4.87,0,0,0-.93-2.79,2.58,2.58,0,0,0-2.14-1,3.14,3.14,0,0,0-2.54,1.08,4.59,4.59,0,0,0-.9,3v1.87a3.78,3.78,0,0,0,1,2.8,3.67,3.67,0,0,0,2.72,1,4.71,4.71,0,0,0,1.75-.35,5,5,0,0,0,1.54-1l1.9,1.9a8,8,0,0,1-2.45,1.62A6.89,6.89,0,0,1,926.94,1098.22Z",
    transform: "translate(-656 -580.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M936.47,1104v-20.67h2.89V1104Zm6.59-5.76a4.29,4.29,0,0,1-2.39-.66,3.93,3.93,0,0,1-1.51-1.86l.2-3.08a3.62,3.62,0,0,0,.34,1.62,2.43,2.43,0,0,0,1,1,3.27,3.27,0,0,0,1.56.35,2.84,2.84,0,0,0,2.22-.87,3.56,3.56,0,0,0,.78-2.46v-3.18a3.7,3.7,0,0,0-.78-2.51,2.82,2.82,0,0,0-2.22-.89,3.27,3.27,0,0,0-1.56.34,2.36,2.36,0,0,0-1,1,3.46,3.46,0,0,0-.34,1.59l-.29-2.84a5.07,5.07,0,0,1,1.74-2,4.32,4.32,0,0,1,2.39-.7,4.47,4.47,0,0,1,3.65,1.57,6.77,6.77,0,0,1,1.29,4.42v3.2a6.53,6.53,0,0,1-1.33,4.38A4.67,4.67,0,0,1,943.06,1098.22Z",
    transform: "translate(-656 -580.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M952.25,1098v-14.69h2.89V1098Zm8.08-11.21a2.37,2.37,0,0,0-1-.71,3.48,3.48,0,0,0-1.34-.24,2.85,2.85,0,0,0-2.13.76,2.8,2.8,0,0,0-.76,2.1l-.3-2.83a5.32,5.32,0,0,1,1.75-2,4.16,4.16,0,0,1,2.38-.74,5.43,5.43,0,0,1,1.82.29,4.14,4.14,0,0,1,1.43.86Z",
    transform: "translate(-656 -580.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M964.62,1080.3v-2.88h2.89v2.88Zm0,17.7v-14.69h2.89V1098Z",
    transform: "translate(-656 -580.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M977.1,1098.22a10.25,10.25,0,0,1-3.55-.58,8.34,8.34,0,0,1-2.85-1.72l1.71-2.11a9.82,9.82,0,0,0,2.37,1.36,6.43,6.43,0,0,0,2.32.46,4.89,4.89,0,0,0,2.57-.54,1.74,1.74,0,0,0,.86-1.59,1.23,1.23,0,0,0-.58-1.16,3.69,3.69,0,0,0-1.5-.45c-.62-.07-1.28-.13-2-.17s-1.18-.12-1.77-.22a5.21,5.21,0,0,1-1.6-.54,2.92,2.92,0,0,1-1.15-1.16,4.14,4.14,0,0,1-.43-2,4.23,4.23,0,0,1,1.43-3.5,6.66,6.66,0,0,1,4.26-1.16,10.69,10.69,0,0,1,3.21.47,9.47,9.47,0,0,1,2.79,1.43l-1.74,2.11a9.62,9.62,0,0,0-2.17-1.06,6.56,6.56,0,0,0-2.09-.36,3.9,3.9,0,0,0-2.21.51,1.71,1.71,0,0,0-.74,1.51,1,1,0,0,0,.51,1,3.55,3.55,0,0,0,1.35.38l1.8.15q.92.06,1.86.21a5.5,5.5,0,0,1,1.73.57,3.16,3.16,0,0,1,1.28,1.26,4.6,4.6,0,0,1,.48,2.28,4.15,4.15,0,0,1-1.54,3.54A7.55,7.55,0,0,1,977.1,1098.22Z",
    transform: "translate(-656 -580.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M993,1098.22a6.34,6.34,0,0,1-4.76-1.72,6.65,6.65,0,0,1-1.68-4.87V1090a7.34,7.34,0,0,1,1.62-5.08,5.82,5.82,0,0,1,4.56-1.8,5,5,0,0,1,4.3,2,9.37,9.37,0,0,1,1.52,5.72v1h-9.91v-2.33h7.17a5,5,0,0,0-.93-2.79,2.6,2.6,0,0,0-2.15-1,3.12,3.12,0,0,0-2.53,1.08,4.6,4.6,0,0,0-.91,3v1.87a3.82,3.82,0,0,0,1,2.8,3.69,3.69,0,0,0,2.73,1,4.66,4.66,0,0,0,1.74-.35,4.93,4.93,0,0,0,1.54-1l1.9,1.9a7.92,7.92,0,0,1-2.45,1.62A6.84,6.84,0,0,1,993,1098.22Z",
    transform: "translate(-656 -580.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntrepriseRecto);
export default __webpack_public_path__ + "static/media/entreprise_recto.db1d4781817ece66768ef6876cfa907b.svg";
export { ForwardRef as ReactComponent };